module.exports = ".page-login-v4 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100vw;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.page-login-v4 > .page-login-v4__form {\n    width: 400px;\n    height: 100vh;\n    background-color: white;\n}\n\n.page-login-v4 > .page-login-v4__background {\n    width: calc(100vw-400px);\n}\n\n.page-login-v4 > .page-login-v4__background > img {\n    width: 100%;\n    height: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/auth/login.component.css
// module id = ./src/app/pages/admin/auth/login.component.css
// module chunks = main